import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { contactMes } from '@portalCommon/constants';
import { StyledButton } from '@portalCommon/components/StyledButton';
import { toJoinUsPage } from '@portalCommon/utils';
import { Tooltip } from '@fuxi/eevee-ui';

import classnames from 'classnames/bind';
import styles from './index.module.less';

const cx = classnames.bind(styles);

const AboutFuxi = () => {
  const { t } = useTranslation();
  const [text, setText] = useState<string>('contactUs.cooperate.copy');
  const emailRef = useRef<HTMLInputElement>(null);

  const copy = () => {
    emailRef.current && emailRef.current.select();
    document.execCommand('copy');
    setTimeout(() => {
      setText('contactUs.cooperate.cpySucc');
    }, 51);
  };

  return (
    <div className={cx('background-wrapper', 'fuxi-wrapper')}>
      <div className={cx('content-wrapper', 'fuxi-content')}>
        <h1 className={cx('title-h1')}>{t('knowUs.fuxi.title')}</h1>
        <span className={cx('detail-span')}>{t('knowUs.fuxi.detail')}</span>
        <div className={cx('desc-wrapper')}>
          <h2 className={cx('desc-h2')}>{t('knowUs.fuxi.desc1')}</h2>
          <h2 className={cx('desc-h2', 'highlight-desc-h2')}>{t('knowUs.fuxi.desc2')}</h2>
        </div>
        <StyledButton
          style={{ width: 189, height: 46, fontSize: 20, fontWeight: 600, letterSpacing: 4 }}
          styleType="gradient"
          onClick={() => {
            toJoinUsPage();
          }}>
          {t('knowUs.fuxi.button')}
        </StyledButton>
      </div>
      <div className={cx('address-wrapper')}>
        <p className={cx('address-p')}>{t('knowUs.fuxi.address')}</p>
        <p className={cx('address-p')}>{t('knowUs.fuxi.phone')}</p>
        <div className={cx('email-wrapper')}>
          <p className={cx('address-p')}>{`${t('knowUs.fuxi.email')}${contactMes.email}`}</p>
          <input ref={emailRef} type="text" defaultValue={contactMes.email} className={cx('email-hide')} />
          <Tooltip
            placement="right"
            title={t(text)}
            mouseLeaveDelay={1}
            onOpenChange={() =>
              setTimeout(() => {
                setText('contactUs.cooperate.copy');
              }, 50)
            }>
            <div className={cx('copy-btn')} onClick={copy} />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default AboutFuxi;
